import * as React from 'react';
import classNames from 'classnames';
import { v4 as uuid } from 'uuid';

import Text from '../Text';
import { FontSizeProps } from '../../../@types/theme';

import styles from './Radio.module.scss';

// Interfaces
// //////////////////////////

export interface Props extends React.HTMLAttributes<HTMLElement> {
  name: string;
  label: string;
  description?: string;
  ellipsize?: boolean;
  value: string;
  textSize?: FontSizeProps;
  checked?: boolean;
  disabled?: boolean;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
}

/**
 * <Radio> component
 */
export const Radio: React.FunctionComponent<Props> = ({
  id,
  className,
  style,
  name,
  label,
  description,
  ellipsize = true,
  value,
  textSize = 'md',
  checked,
  disabled,
  onChange,
  ...htmlElementProps
}) => {
  const inputId = id ?? uuid();
  return (
    <label
      htmlFor={inputId}
      className={classNames(styles.label, className, {
        disabled,
        ellipsize,
        checked,
      })}
      title={label}
      {...htmlElementProps}
    >
      <input
        id={inputId}
        type="radio"
        className={styles.radio}
        name={name}
        value={value}
        checked={checked}
        disabled={disabled}
        onChange={onChange}
      />

      <div>
        <Text as="span" size={textSize} weight={checked ? 'bold' : 'light'}>
          {label}

          {description && (
            <Text size="sm2" color="gray100">
              {description}
            </Text>
          )}
        </Text>
      </div>
    </label>
  );
};

export default Radio;
